// @flow
import { AppSidebar } from 'bk-web-app/app-sidebar';
import { ClientIdContext } from 'bk-web-app';
import React from 'react';
import { JournalEntrySidebar } from 'journal-entry-sidebar';
import { NullState } from 'bench-internal-theme';
// $FlowFixMe - TS file
import { SelectedDataEntriesProvider } from 'general-ledger';
import { WrappedSpinner } from 'spinner';

import IssuesView from './IssuesView';
import SequentialQueries from './SequentialQueries';
import { GET_CATEGORIZATION_INCONSISTENCIES } from './queries';

import type { DateRange } from './types';
import compileIssuesViewData from './compileIssuesViewData';
import makeClientBooksQueries from './makeClientBooksQueries';
import mergeDatasets from './mergeDatasets';

type IssuesViewContainerProps = {
  dateRange: DateRange,
  search: string,
};

const IssuesViewContainer = ({ dateRange, search }: IssuesViewContainerProps) => (
  <ClientIdContext.Consumer>
    {clientId => (
      <SequentialQueries
        queries={makeClientBooksQueries({
          dateRange,
          clientId,
          supplementalQueriesForRange: [GET_CATEGORIZATION_INCONSISTENCIES],
        })}
      >
        {(getClientBooks: any) => {
          if (getClientBooks.loading) {
            return <WrappedSpinner />;
          }

          if (getClientBooks.error || !getClientBooks.data) {
            return (
              <NullState
                bigEmoji="🙈"
                description="Uh oh! There seems to be a problem, sorry!"
                title="We were unable to retrieve the quality issues."
              />
            );
          }
          const [, inconsistenciesData] = getClientBooks.data.find(
            ([key]) => key === 'categorizationInconsistencies',
          );
          if (inconsistenciesData.length === 0) {
            return (
              <NullState
                bigEmoji="🤩"
                description="Great job keeping tidy books."
                title="You have no quality issues to review!"
              />
            );
          }
          const {
            addOns,
            categorizationInconsistencies,
            dataEntries,
            journalEntries,
            ledgerAccounts,
          } = mergeDatasets(getClientBooks.data);
          const { dataEntriesWithInconsistencies } = compileIssuesViewData(
            addOns,
            categorizationInconsistencies,
            dataEntries,
            journalEntries,
            ledgerAccounts,
          );
          return (
            <SelectedDataEntriesProvider>
              <AppSidebar>
                {({ closeSidebar, openSidebar, openerMeta }) => {
                  const selectedDataEntry =
                    // eslint-disable-next-line no-underscore-dangle
                    openerMeta && openerMeta.__typename === 'DataEntry' ? openerMeta : undefined;
                  const toggleDataEntry = dataEntry => {
                    if (dataEntry && dataEntry !== openerMeta) {
                      openSidebar(
                        <JournalEntrySidebar
                          dismiss={closeSidebar}
                          journalEntryId={dataEntry.journalEntry.id}
                          key={dataEntry.journalEntry.id}
                        />,
                        dataEntry,
                      );
                    } else {
                      closeSidebar();
                    }
                  };
                  return (
                    <IssuesView
                      dataEntriesWithInconsistencies={dataEntriesWithInconsistencies}
                      search={search}
                      selectedDataEntry={selectedDataEntry}
                      toggleDataEntry={toggleDataEntry}
                    />
                  );
                }}
              </AppSidebar>
            </SelectedDataEntriesProvider>
          );
        }}
      </SequentialQueries>
    )}
  </ClientIdContext.Consumer>
);
export default IssuesViewContainer;
